import { Keyboard } from "lucide-react";

// Barra inferior tipo "status bar" siempre visible: recordatorio operativo
// de las teclas más usadas. Los items pueden hacer flash cuando se activa el atajo.
function StatusItem({ shortcut, label, active, testid, onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid={testid}
      className={`group flex items-center gap-1.5 px-2 py-1 rounded-md border transition-colors ${
        active
          ? "border-primary bg-primary/25 ring-1 ring-primary text-foreground"
          : "border-border/60 bg-secondary/40 hover:bg-secondary/70 text-muted-foreground"
      }`}
    >
      <kbd
        className={`inline-flex items-center px-1.5 py-0.5 rounded border font-mono text-[10px] font-semibold ${
          active
            ? "border-primary/60 bg-background text-primary"
            : "border-border bg-background/70 text-foreground"
        }`}
      >
        {shortcut}
      </kbd>
      <span className="text-[11px] font-medium">{label}</span>
    </button>
  );
}

export default function ShortcutStatusBar({ flashKey, onHelp, onEmit, onAdd, onClear, onCurrency, onRepeat, onReprint, onVoidLast, onSession }) {
  return (
    <div
      data-testid="pos-shortcut-status-bar"
      className="fixed bottom-0 left-0 right-0 z-30 bg-card/95 backdrop-blur border-t border-border py-1.5 px-3 flex items-center gap-1.5 overflow-x-auto"
    >
      <div className="flex items-center gap-1.5 text-muted-foreground shrink-0 mr-1">
        <Keyboard size={13} />
        <span className="text-[10px] uppercase tracking-widest">Atajos</span>
      </div>
      <div className="flex items-center gap-1.5 flex-nowrap">
        <StatusItem shortcut="F1" label="Ayuda" active={flashKey === "f1"} onClick={onHelp} testid="pos-shortcut-f1" />
        <StatusItem shortcut="+" label="Agregar" active={flashKey === "add"} onClick={onAdd} testid="pos-shortcut-add" />
        <StatusItem shortcut="F8" label="Emitir" active={flashKey === "f8"} onClick={onEmit} testid="pos-shortcut-f8" />
        <StatusItem shortcut="F2" label="Bs/USD" active={flashKey === "f2"} onClick={onCurrency} testid="pos-shortcut-f2" />
        <StatusItem shortcut="F3" label="Repetir" active={flashKey === "f3"} onClick={onRepeat} testid="pos-shortcut-f3" />
        <StatusItem shortcut="F4" label="Reimprimir" active={flashKey === "f4"} onClick={onReprint} testid="pos-shortcut-f4" />
        <StatusItem shortcut="F5" label="Anular últ." active={flashKey === "f5"} onClick={onVoidLast} testid="pos-shortcut-f5" />
        <StatusItem shortcut="F7" label="Caja" active={flashKey === "f7"} onClick={onSession} testid="pos-shortcut-f7" />
        <StatusItem shortcut="F10" label="Limpiar" active={flashKey === "f10"} onClick={onClear} testid="pos-shortcut-f10" />
      </div>
      <div className="ml-auto text-[10px] text-muted-foreground shrink-0 hidden md:block">
        Pulsa <b className="text-foreground">F1</b> para ver todos los atajos
      </div>
    </div>
  );
}
